import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Project',
    field: 'projectName',
    filter: 'text',
    searchable: true,
    width: '250',
    navigate: true,
  },
  {
    title: 'Project Code',
    field: 'projectCode',
    filter: 'text',
    width: '150',
    searchable: true,
  },
  {
    title: 'Builder Code',
    field: 'builderCode',
    filter: 'text',
    width: '150',
    searchable: true,
  },
  {
    title: 'Project Type',
    field: 'projectType',
    filter: 'text',
    searchable: true,
    width: '150',
  },
  {
    title: 'Office',
    field: 'officeName',
    filter: 'text',
    searchable: true,
    width: '250',
  },
  {
    title: 'Contacts',
    field: 'projectContactsCount',
    filter: 'text',
    searchable: true,
    width: '130',
  },
  {
    title: 'Lots/Units',
    field: 'unitsCount',
    filter: 'text',
    width: '130',
  },
  {
    title: 'Work Orders',
    field: 'workOrderCount',
    filter: 'text',
    width: '130',
  },
  // {
  //   title: 'Plans',
  //   field: 'plansCount',
  //   filter: 'numeric',
  //   searchable: true,
  //   width: '130',
  // },
  {
    title: 'Purchase Orders',
    field: 'purchaseOrders',
    filter: 'text',
  },
  {
    title: 'Created On',
    field: 'createdOn',
    filter: 'text',
  },
];
